import { render } from "./H5_page_setting.vue?vue&type=template&id=1c424572&scoped=true"
import script from "./H5_page_setting.vue?vue&type=script&lang=js"
export * from "./H5_page_setting.vue?vue&type=script&lang=js"

import "./H5_page_setting.vue?vue&type=style&index=0&id=1c424572&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c424572"]])

export default __exports__